const Header=()=> {
    if(window.localStorage.getItem('token')){
        return {headers:{"x-access-token":window.localStorage.getItem('token')}}
    }
    else return{}
    
}

export default Header;